(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sizechart-emerge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('emerge-size-chart')) {
    customElements.define('emerge-size-chart', class extends HTMLElement {
      connectedCallback() {
        if (this.emergeUnitsBound) return;
        this.emergeUnitsBound = true;
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-emerge-units]')) return;
          const unit = event.target.value === 'cm' ? 'cm' : 'in';
          this.querySelectorAll('[data-fc-in]').forEach(cell => {
            cell.textContent = cell.getAttribute('data-fc-' + unit);
          });
          this.querySelectorAll('[data-fc-unit-label]').forEach(label => {
            label.textContent = label.getAttribute('data-' + unit + '-label');
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
